module.exports = "/static/259594a09328b816df02ba602b75377b.png";